import { RadioCardGroup } from '@insurance/components'
import { useValidationsField } from '@insurance/hooks'
import { Form } from 'antd'
import { useTranslation } from 'react-i18next'

const colProps = { xs: 24, lg: 12 }

export const CovidInsurance = () => {
  const { t } = useTranslation()
  const { required } = useValidationsField()

  return (
    <Form.Item name="covid" label={t('covid_insurance')} rules={[required]}>
      <RadioCardGroup
        options={[
          { value: true, label: t('includes_covid_risk'), colProps },
          { value: false, label: t('not_includes_covid_risk'), colProps }
        ]}
      />
    </Form.Item>
  )
}
